import React from "react";
import classnames from "classnames";

import currencyFormatter from "utils/currencyFormatter";
import { formatQuantity } from "utils/formatQuantity";

import OfferLabel from "../OfferLabel";

const ProductCardPrice: React.FC<{
  dealDiscountLabel: string | null;
  displayPrice: number;
  countryCode: string;
  offerLabel: string | null;
  quantity: number | null;
  regularPrice: number | null;
  unit: string | null;
  className?: string;
}> = ({
  countryCode,
  dealDiscountLabel,
  displayPrice,
  quantity,
  offerLabel,
  regularPrice,
  unit,
  className,
}) => {
  return (
    <div className="text-xs font-bold text-grey">
      starting at
      <div className={classnames("text-sm font-bold text-default", className)}>
        <div className="flex items-center justify-start">
          <div
            className={classnames("font-bold text-lg", {
              "text-notification": dealDiscountLabel,
            })}
            data-testid="menu-item-card__price"
          >
            {`${currencyFormatter(displayPrice, countryCode)}`}
          </div>
          {unit && quantity && (
            <div className="font-bold text-xs pl-xs">
              {formatQuantity({
                size: quantity,
                unit,
              })}
            </div>
          )}
        </div>
        {dealDiscountLabel && (
          <div data-testid="deal-section" className="flex items-center text-xs">
            <div
              data-testid="discount-label"
              className="bg-notification rounded text-white font-bold px-sm"
            >
              {dealDiscountLabel}
            </div>
            <span className="pl-sm text-grey font-normal">{`reg ${currencyFormatter(
              regularPrice,
              countryCode,
            )}`}</span>
          </div>
        )}
        {!dealDiscountLabel && offerLabel && (
          <div data-testid="offer-section" className="whitespace-nowrap">
            <OfferLabel label={offerLabel} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductCardPrice;
